import * as moment from 'moment';

export class DateRange {
    startDate: string;
    endDate: string;

    static empty(): DateRange {
        const range = new DateRange();
        range.startDate = null;
        range.endDate = null;
        return range;
    }
    static today(): DateRange {
        const range = new DateRange();
        range.startDate = moment().startOf('day').toISOString();
        range.endDate = moment().endOf('day').toISOString();
        return range;
    }
    static getRangeByDuration(durationType: string): DateRange {
        const range = new DateRange();
        let duration = 6;
        switch (durationType) {
            case '1M':
                duration = 30;
                break;
            case '3M':
                duration = 90;
                break;
            case '6M':
                duration = 180;
                break;
            case '1W':
            default:
                duration = 6;
        }
        range.startDate = moment().subtract(duration, 'days').startOf('day').toISOString();
        range.endDate = moment().endOf('day').toISOString();
        return range;
    }
    getDates(): Date[] {
        return [moment(this.startDate).toDate(), moment(this.endDate).toDate()];
    }
}

export class MomentHelper {
    static createDateRange(...args: any[]): DateRange {
        const range = new DateRange();
        if (args[0].length === 1) {
            range.startDate = moment(args[0][0]).startOf('day').toISOString();
        } else if (args[0].length > 1) {
            range.startDate = moment(args[0][0]).startOf('day').toISOString();
            range.endDate = moment(args[0][1]).endOf('day').toISOString();
        }
        return range;
    }
}
